module.exports = __webpack_public_path__ + "img/c06_unitspearman_Normal_ua.f25a60bb.webp";